import { UTCDate } from '@date-fns/utc';
import { DataEntities } from './data-provider';

export const getSortedData = (data: DataEntities) => {
  const { accounts, transactions, categories } = data;

  // Sort accounts by balance in descending order (highest to lowest)
  accounts.sort((a, b) => (b.balance || 0) - (a.balance || 0));

  // All transaction views in the app should be sorted by date by default
  transactions.sort((a, b) => new UTCDate(b.fspDate || '').getTime() - new UTCDate(a.fspDate || '').getTime());

  // Categories are sorted based in the `order` field determined by the backend
  categories.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return data;
};
